import React, {useEffect} from 'react';
import {Box} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import {StaffSearchInput} from '../../components/StaffSearchInput/StaffSearchInput';
import {BusinessUnitSearch} from '../../components/BusinessUnitSearch/BusinessUnitSearch';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';

type StaffSearchType = {
  staff: string;
  staffSearchTerm: string;
  businessUnitId: string;
};

export const StaffSearchPage: React.FC = () => {
  return <StaffSearchWrapped formFields={[]} />;
};

const StaffSearchInner: React.FC = () => {
  const {values} = useAutoForm<StaffSearchType>();
  const navigate = useNavigate();
  useEffect(() => {
    if (values.staff) {
      navigate({pathname: `/staff/${values.staff}`});
    }
  }, [values.staff]);
  return (
    <Box display="flex" p={2} bgcolor="white" borderRadius="3px">
      <Box flex={3}>
        <StaffSearchInput
          businessUnitIds={values.businessUnitId ? [values.businessUnitId] : null}
        />
      </Box>
      <Box flex={1} ml={3}>
        <BusinessUnitSearch />
      </Box>
    </Box>
  );
};

export const StaffSearchWrapped = withAutoFormNew<StaffSearchType, object>(
  StaffSearchInner,
  undefined,
  {debugPosition: 'right'}
);
